import { INTERFACE_PERMISSIONS, PaySchedule } from '@vyce/core/src/types';
import { isOutsourcedOnlyCompany } from '@vyce/core/src/utils/payroll';

import { usePermissions } from './usePermissions';

/**
 * Whether the selected company runs payroll entirely through Vyce, which is the
 * second half of every payroll visibility decision (the first being the permission).
 *
 * Pass the schedules whenever the screen has them — that is the exact answer, and
 * the only one that works for an owner. Without them it falls back to the menu
 * flags, which is enough to recognise an outsourced-only company for everyone else.
 */
export const useOutsourcedOnlyCompany = (paySchedules?: PaySchedule[]): boolean => {
  const { can, isOwner } = usePermissions();

  return isOutsourcedOnlyCompany(paySchedules, {
    canAccessPayroll: can(INTERFACE_PERMISSIONS.PAYROLL),
    canAccessPayrollOutsourced: can(INTERFACE_PERMISSIONS.PAYROLL_OUTSOURCED),
    isOwner,
  });
};
